













import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class TongueMoreControlBtn extends Vue {
  @Prop()
  private tongue;
  /**
   * @description 处理点击更多选项
   */
  private handleMoreControl(command) {
    this.$emit("more", command, this.tongue);
  }
}
